import styled from "styled-components";
import { ssm } from "../../../AppTheme.styled";

const StyledProfileIcon = styled.div<{ size?: number }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.background3};
  color: ${({ theme }) => theme.palette.primary};
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 50%;
  }

  ${ssm} {
    width: 40px;
    height: 40px;
  }
`;

export default StyledProfileIcon;
